import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, CheckCircle2Icon, AlertCircleIcon } from 'lucide-react';
interface ApplicationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOpenTerms: () => void;
  onOpenPrivacy: () => void;
}
const countries = ['Afganistán', 'Albania', 'Alemania', 'Andorra', 'Angola', 'Antigua y Barbuda', 'Arabia Saudita', 'Argelia', 'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaiyán', 'Bahamas', 'Bangladés', 'Barbados', 'Baréin', 'Bélgica', 'Belice', 'Benín', 'Bielorrusia', 'Birmania', 'Bolivia', 'Bosnia y Herzegovina', 'Botsuana', 'Brasil', 'Brunéi', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Bután', 'Cabo Verde', 'Camboya', 'Camerún', 'Canadá', 'Catar', 'Chad', 'Chile', 'China', 'Chipre', 'Colombia', 'Comoras', 'Congo', 'Corea del Norte', 'Corea del Sur', 'Costa de Marfil', 'Costa Rica', 'Croacia', 'Cuba', 'Dinamarca', 'Dominica', 'Ecuador', 'Egipto', 'El Salvador', 'Emiratos Árabes Unidos', 'Eritrea', 'Eslovaquia', 'Eslovenia', 'España', 'Estados Unidos', 'Estonia', 'Etiopía', 'Filipinas', 'Finlandia', 'Fiyi', 'Francia', 'Gabón', 'Gambia', 'Georgia', 'Ghana', 'Granada', 'Grecia', 'Guatemala', 'Guinea', 'Guinea Ecuatorial', 'Guinea-Bisáu', 'Guyana', 'Haití', 'Honduras', 'Hungría', 'India', 'Indonesia', 'Irak', 'Irán', 'Irlanda', 'Islandia', 'Islas Marshall', 'Islas Salomón', 'Israel', 'Italia', 'Jamaica', 'Japón', 'Jordania', 'Kazajistán', 'Kenia', 'Kirguistán', 'Kiribati', 'Kuwait', 'Laos', 'Lesoto', 'Letonia', 'Líbano', 'Liberia', 'Libia', 'Liechtenstein', 'Lituania', 'Luxemburgo', 'Macedonia del Norte', 'Madagascar', 'Malasia', 'Malaui', 'Maldivas', 'Malí', 'Malta', 'Marruecos', 'Mauricio', 'Mauritania', 'México', 'Micronesia', 'Moldavia', 'Mónaco', 'Mongolia', 'Montenegro', 'Mozambique', 'Namibia', 'Nauru', 'Nepal', 'Nicaragua', 'Níger', 'Nigeria', 'Noruega', 'Nueva Zelanda', 'Omán', 'Países Bajos', 'Pakistán', 'Palaos', 'Panamá', 'Papúa Nueva Guinea', 'Paraguay', 'Perú', 'Polonia', 'Portugal', 'Reino Unido', 'República Centroafricana', 'República Checa', 'República del Congo', 'República Democrática del Congo', 'República Dominicana', 'Ruanda', 'Rumania', 'Rusia', 'Samoa', 'San Cristóbal y Nieves', 'San Marino', 'San Vicente y las Granadinas', 'Santa Lucía', 'Santo Tomé y Príncipe', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leona', 'Singapur', 'Siria', 'Somalia', 'Sri Lanka', 'Suazilandia', 'Sudáfrica', 'Sudán', 'Sudán del Sur', 'Suecia', 'Suiza', 'Surinam', 'Tailandia', 'Tanzania', 'Tayikistán', 'Timor Oriental', 'Togo', 'Tonga', 'Trinidad y Tobago', 'Túnez', 'Turkmenistán', 'Turquía', 'Tuvalu', 'Ucrania', 'Uganda', 'Uruguay', 'Uzbekistán', 'Vanuatu', 'Vaticano', 'Venezuela', 'Vietnam', 'Yemen', 'Yibuti', 'Zambia', 'Zimbabue'];
const phoneCodes = [{
  code: '+93',
  country: 'Afganistán'
}, {
  code: '+355',
  country: 'Albania'
}, {
  code: '+213',
  country: 'Argelia'
}, {
  code: '+376',
  country: 'Andorra'
}, {
  code: '+244',
  country: 'Angola'
}, {
  code: '+1-268',
  country: 'Antigua y Barbuda'
}, {
  code: '+54',
  country: 'Argentina'
}, {
  code: '+374',
  country: 'Armenia'
}, {
  code: '+297',
  country: 'Aruba'
}, {
  code: '+61',
  country: 'Australia'
}, {
  code: '+43',
  country: 'Austria'
}, {
  code: '+994',
  country: 'Azerbaiyán'
}, {
  code: '+1-242',
  country: 'Bahamas'
}, {
  code: '+973',
  country: 'Baréin'
}, {
  code: '+880',
  country: 'Bangladés'
}, {
  code: '+1-246',
  country: 'Barbados'
}, {
  code: '+375',
  country: 'Bielorrusia'
}, {
  code: '+32',
  country: 'Bélgica'
}, {
  code: '+501',
  country: 'Belice'
}, {
  code: '+229',
  country: 'Benín'
}, {
  code: '+1-441',
  country: 'Bermudas'
}, {
  code: '+975',
  country: 'Bután'
}, {
  code: '+591',
  country: 'Bolivia'
}, {
  code: '+387',
  country: 'Bosnia y Herzegovina'
}, {
  code: '+267',
  country: 'Botsuana'
}, {
  code: '+55',
  country: 'Brasil'
}, {
  code: '+673',
  country: 'Brunéi'
}, {
  code: '+359',
  country: 'Bulgaria'
}, {
  code: '+226',
  country: 'Burkina Faso'
}, {
  code: '+257',
  country: 'Burundi'
}, {
  code: '+238',
  country: 'Cabo Verde'
}, {
  code: '+855',
  country: 'Camboya'
}, {
  code: '+237',
  country: 'Camerún'
}, {
  code: '+1',
  country: 'Canadá'
}, {
  code: '+235',
  country: 'Chad'
}, {
  code: '+56',
  country: 'Chile'
}, {
  code: '+86',
  country: 'China'
}, {
  code: '+357',
  country: 'Chipre'
}, {
  code: '+57',
  country: 'Colombia'
}, {
  code: '+269',
  country: 'Comoras'
}, {
  code: '+242',
  country: 'Congo'
}, {
  code: '+243',
  country: 'Congo (RDC)'
}, {
  code: '+850',
  country: 'Corea del Norte'
}, {
  code: '+82',
  country: 'Corea del Sur'
}, {
  code: '+225',
  country: 'Costa de Marfil'
}, {
  code: '+506',
  country: 'Costa Rica'
}, {
  code: '+385',
  country: 'Croacia'
}, {
  code: '+53',
  country: 'Cuba'
}, {
  code: '+599',
  country: 'Curazao'
}, {
  code: '+45',
  country: 'Dinamarca'
}, {
  code: '+253',
  country: 'Yibuti'
}, {
  code: '+1-767',
  country: 'Dominica'
}, {
  code: '+593',
  country: 'Ecuador'
}, {
  code: '+20',
  country: 'Egipto'
}, {
  code: '+503',
  country: 'El Salvador'
}, {
  code: '+971',
  country: 'Emiratos Árabes Unidos'
}, {
  code: '+291',
  country: 'Eritrea'
}, {
  code: '+421',
  country: 'Eslovaquia'
}, {
  code: '+386',
  country: 'Eslovenia'
}, {
  code: '+34',
  country: 'España'
}, {
  code: '+1',
  country: 'Estados Unidos'
}, {
  code: '+372',
  country: 'Estonia'
}, {
  code: '+251',
  country: 'Etiopía'
}, {
  code: '+63',
  country: 'Filipinas'
}, {
  code: '+358',
  country: 'Finlandia'
}, {
  code: '+679',
  country: 'Fiyi'
}, {
  code: '+33',
  country: 'Francia'
}, {
  code: '+241',
  country: 'Gabón'
}, {
  code: '+220',
  country: 'Gambia'
}, {
  code: '+995',
  country: 'Georgia'
}, {
  code: '+233',
  country: 'Ghana'
}, {
  code: '+350',
  country: 'Gibraltar'
}, {
  code: '+1-473',
  country: 'Granada'
}, {
  code: '+30',
  country: 'Grecia'
}, {
  code: '+299',
  country: 'Groenlandia'
}, {
  code: '+590',
  country: 'Guadalupe'
}, {
  code: '+1-671',
  country: 'Guam'
}, {
  code: '+502',
  country: 'Guatemala'
}, {
  code: '+224',
  country: 'Guinea'
}, {
  code: '+240',
  country: 'Guinea Ecuatorial'
}, {
  code: '+245',
  country: 'Guinea-Bisáu'
}, {
  code: '+592',
  country: 'Guyana'
}, {
  code: '+509',
  country: 'Haití'
}, {
  code: '+504',
  country: 'Honduras'
}, {
  code: '+852',
  country: 'Hong Kong'
}, {
  code: '+36',
  country: 'Hungría'
}, {
  code: '+91',
  country: 'India'
}, {
  code: '+62',
  country: 'Indonesia'
}, {
  code: '+98',
  country: 'Irán'
}, {
  code: '+964',
  country: 'Irak'
}, {
  code: '+353',
  country: 'Irlanda'
}, {
  code: '+354',
  country: 'Islandia'
}, {
  code: '+692',
  country: 'Islas Marshall'
}, {
  code: '+677',
  country: 'Islas Salomón'
}, {
  code: '+972',
  country: 'Israel'
}, {
  code: '+39',
  country: 'Italia'
}, {
  code: '+1-876',
  country: 'Jamaica'
}, {
  code: '+81',
  country: 'Japón'
}, {
  code: '+962',
  country: 'Jordania'
}, {
  code: '+7',
  country: 'Kazajistán'
}, {
  code: '+254',
  country: 'Kenia'
}, {
  code: '+996',
  country: 'Kirguistán'
}, {
  code: '+686',
  country: 'Kiribati'
}, {
  code: '+383',
  country: 'Kosovo'
}, {
  code: '+965',
  country: 'Kuwait'
}, {
  code: '+856',
  country: 'Laos'
}, {
  code: '+266',
  country: 'Lesoto'
}, {
  code: '+371',
  country: 'Letonia'
}, {
  code: '+961',
  country: 'Líbano'
}, {
  code: '+231',
  country: 'Liberia'
}, {
  code: '+218',
  country: 'Libia'
}, {
  code: '+423',
  country: 'Liechtenstein'
}, {
  code: '+370',
  country: 'Lituania'
}, {
  code: '+352',
  country: 'Luxemburgo'
}, {
  code: '+853',
  country: 'Macao'
}, {
  code: '+389',
  country: 'Macedonia del Norte'
}, {
  code: '+261',
  country: 'Madagascar'
}, {
  code: '+60',
  country: 'Malasia'
}, {
  code: '+265',
  country: 'Malaui'
}, {
  code: '+960',
  country: 'Maldivas'
}, {
  code: '+223',
  country: 'Malí'
}, {
  code: '+356',
  country: 'Malta'
}, {
  code: '+212',
  country: 'Marruecos'
}, {
  code: '+596',
  country: 'Martinica'
}, {
  code: '+230',
  country: 'Mauricio'
}, {
  code: '+222',
  country: 'Mauritania'
}, {
  code: '+262',
  country: 'Mayotte'
}, {
  code: '+52',
  country: 'México'
}, {
  code: '+691',
  country: 'Micronesia'
}, {
  code: '+373',
  country: 'Moldavia'
}, {
  code: '+377',
  country: 'Mónaco'
}, {
  code: '+976',
  country: 'Mongolia'
}, {
  code: '+382',
  country: 'Montenegro'
}, {
  code: '+1-664',
  country: 'Montserrat'
}, {
  code: '+258',
  country: 'Mozambique'
}, {
  code: '+95',
  country: 'Birmania'
}, {
  code: '+264',
  country: 'Namibia'
}, {
  code: '+674',
  country: 'Nauru'
}, {
  code: '+977',
  country: 'Nepal'
}, {
  code: '+505',
  country: 'Nicaragua'
}, {
  code: '+227',
  country: 'Níger'
}, {
  code: '+234',
  country: 'Nigeria'
}, {
  code: '+683',
  country: 'Niue'
}, {
  code: '+47',
  country: 'Noruega'
}, {
  code: '+687',
  country: 'Nueva Caledonia'
}, {
  code: '+64',
  country: 'Nueva Zelanda'
}, {
  code: '+968',
  country: 'Omán'
}, {
  code: '+31',
  country: 'Países Bajos'
}, {
  code: '+92',
  country: 'Pakistán'
}, {
  code: '+680',
  country: 'Palaos'
}, {
  code: '+970',
  country: 'Palestina'
}, {
  code: '+507',
  country: 'Panamá'
}, {
  code: '+675',
  country: 'Papúa Nueva Guinea'
}, {
  code: '+595',
  country: 'Paraguay'
}, {
  code: '+51',
  country: 'Perú'
}, {
  code: '+689',
  country: 'Polinesia Francesa'
}, {
  code: '+48',
  country: 'Polonia'
}, {
  code: '+351',
  country: 'Portugal'
}, {
  code: '+1-787',
  country: 'Puerto Rico'
}, {
  code: '+974',
  country: 'Catar'
}, {
  code: '+44',
  country: 'Reino Unido'
}, {
  code: '+236',
  country: 'República Centroafricana'
}, {
  code: '+420',
  country: 'República Checa'
}, {
  code: '+1-809',
  country: 'República Dominicana'
}, {
  code: '+262',
  country: 'Reunión'
}, {
  code: '+250',
  country: 'Ruanda'
}, {
  code: '+40',
  country: 'Rumania'
}, {
  code: '+7',
  country: 'Rusia'
}, {
  code: '+685',
  country: 'Samoa'
}, {
  code: '+1-684',
  country: 'Samoa Americana'
}, {
  code: '+1-869',
  country: 'San Cristóbal y Nieves'
}, {
  code: '+378',
  country: 'San Marino'
}, {
  code: '+1-758',
  country: 'Santa Lucía'
}, {
  code: '+239',
  country: 'Santo Tomé y Príncipe'
}, {
  code: '+221',
  country: 'Senegal'
}, {
  code: '+381',
  country: 'Serbia'
}, {
  code: '+248',
  country: 'Seychelles'
}, {
  code: '+232',
  country: 'Sierra Leona'
}, {
  code: '+65',
  country: 'Singapur'
}, {
  code: '+1-721',
  country: 'Sint Maarten'
}, {
  code: '+963',
  country: 'Siria'
}, {
  code: '+252',
  country: 'Somalia'
}, {
  code: '+94',
  country: 'Sri Lanka'
}, {
  code: '+268',
  country: 'Suazilandia'
}, {
  code: '+27',
  country: 'Sudáfrica'
}, {
  code: '+249',
  country: 'Sudán'
}, {
  code: '+211',
  country: 'Sudán del Sur'
}, {
  code: '+46',
  country: 'Suecia'
}, {
  code: '+41',
  country: 'Suiza'
}, {
  code: '+597',
  country: 'Surinam'
}, {
  code: '+66',
  country: 'Tailandia'
}, {
  code: '+886',
  country: 'Taiwán'
}, {
  code: '+255',
  country: 'Tanzania'
}, {
  code: '+992',
  country: 'Tayikistán'
}, {
  code: '+670',
  country: 'Timor Oriental'
}, {
  code: '+228',
  country: 'Togo'
}, {
  code: '+676',
  country: 'Tonga'
}, {
  code: '+1-868',
  country: 'Trinidad y Tobago'
}, {
  code: '+216',
  country: 'Túnez'
}, {
  code: '+993',
  country: 'Turkmenistán'
}, {
  code: '+90',
  country: 'Turquía'
}, {
  code: '+688',
  country: 'Tuvalu'
}, {
  code: '+380',
  country: 'Ucrania'
}, {
  code: '+256',
  country: 'Uganda'
}, {
  code: '+598',
  country: 'Uruguay'
}, {
  code: '+998',
  country: 'Uzbekistán'
}, {
  code: '+678',
  country: 'Vanuatu'
}, {
  code: '+379',
  country: 'Vaticano'
}, {
  code: '+58',
  country: 'Venezuela'
}, {
  code: '+84',
  country: 'Vietnam'
}, {
  code: '+967',
  country: 'Yemen'
}, {
  code: '+260',
  country: 'Zambia'
}, {
  code: '+263',
  country: 'Zimbabue'
}];
// Helper function to parse and format error messages
const getErrorMessage = (data: any, response: Response): string => {
  // Check for API response with CodigoRespuesta and DescripcionRespuesta
  if (data?.CodigoRespuesta || data?.DescripcionRespuesta) {
    const codigo = data.CodigoRespuesta;
    const descripcion = data.DescripcionRespuesta || '';
    // CodigoRespuesta "000" typically means success, anything else is an error
    if (codigo !== '000') {
      const lowerDesc = descripcion.toLowerCase();
      // Check for duplicate/already registered
      if (lowerDesc.includes('ya fue registrado') || lowerDesc.includes('ya registrado') || lowerDesc.includes('ya existe')) {
        return 'Este usuario ya está registrado en el sistema. Si necesitas ayuda, contacta con soporte.';
      }
      // Return the API description if available
      if (descripcion) {
        return descripcion;
      }
      // Fallback based on error code
      return `Error ${codigo}: No se pudo completar el registro.`;
    }
  }
  // Check for other common error message fields
  const apiMessage = data?.message || data?.error || data?.mensaje || data?.descripcion;
  if (apiMessage) {
    const lowerMessage = apiMessage.toLowerCase();
    // Check for duplicate/already registered errors
    if (lowerMessage.includes('ya existe') || lowerMessage.includes('ya registrado') || lowerMessage.includes('duplicado') || lowerMessage.includes('already exists') || lowerMessage.includes('duplicate')) {
      return 'Este usuario ya está registrado. Si olvidaste tu contraseña, contacta con soporte.';
    }
    // Check for invalid data errors
    if (lowerMessage.includes('inválido') || lowerMessage.includes('invalid') || lowerMessage.includes('formato incorrecto')) {
      return `Datos inválidos: ${apiMessage}`;
    }
    // Check for missing required fields
    if (lowerMessage.includes('requerido') || lowerMessage.includes('required') || lowerMessage.includes('obligatorio')) {
      return `Campo requerido: ${apiMessage}`;
    }
    // Return the original API message if it's user-friendly
    if (apiMessage.length < 150) {
      return apiMessage;
    }
  }
  // HTTP status-based messages
  if (response.status === 400) {
    return 'Los datos enviados son incorrectos. Por favor verifica la información.';
  }
  if (response.status === 409) {
    return 'Este usuario ya está registrado en el sistema.';
  }
  if (response.status === 500) {
    return 'Error en el servidor. Por favor intenta nuevamente en unos minutos.';
  }
  if (response.status === 503) {
    return 'El servicio no está disponible temporalmente. Intenta más tarde.';
  }
  // Default error message
  return 'Hubo un error al procesar tu registro. Por favor intenta nuevamente o contacta con soporte.';
};
export function ApplicationModal({
  isOpen,
  onClose,
  onOpenTerms,
  onOpenPrivacy
}: ApplicationModalProps) {
  const [documentType, setDocumentType] = useState<'cedula' | 'pasaporte'>('cedula');
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    documentNumber: '',
    nationality: 'Ecuador',
    country: 'Ecuador',
    email: '',
    phoneCode: '+593',
    phoneNumber: '',
    instagram: '',
    tiktok: '',
    acceptTerms: false,
    isAdult: false
  });
  // New states for API integration
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [documentError, setDocumentError] = useState('');
  // Validate document number based on type
  const validateDocumentNumber = (value: string, type: 'cedula' | 'pasaporte'): boolean => {
    if (type === 'cedula') {
      // Cédula: exactly 10 numeric digits
      return /^\d{10}$/.test(value);
    } else {
      // Pasaporte: 3 to 13 alphanumeric characters
      return /^[A-Za-z0-9]{3,13}$/.test(value);
    }
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // Validate document number before submitting
    if (!validateDocumentNumber(formData.documentNumber, documentType)) {
      const errorMsg = documentType === 'cedula' ? 'La cédula debe tener exactamente 10 dígitos numéricos' : 'El pasaporte debe tener entre 3 y 13 caracteres alfanuméricos';
      setDocumentError(errorMsg);
      setErrorMessage(errorMsg);
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
        setDocumentError('');
      }, 5000);
      return;
    }
    setDocumentError('');
    setIsSubmitting(true);
    setShowError(false);
    try {
      const response = await fetch('https://admin.benefika.net/webservice/consumirWebService', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authentication: '01212b6e30dd153561084a5e77a4630d06d6fbbfa9cf732e5bd599f58b00da96'
        },
        body: JSON.stringify({
          TipoIdentificacion: documentType.toUpperCase(),
          Cedula: formData.documentNumber,
          Nombre: formData.firstName,
          Apellido: formData.lastName,
          Email: formData.email,
          Telefono: `${formData.phoneCode}${formData.phoneNumber}`
        })
      });
      let data;
      try {
        data = await response.json();
      } catch (parseError) {
        throw new Error('Error al procesar la respuesta del servidor.');
      }
      // Log the response for debugging
      console.log('API Response:', {
        status: response.status,
        data
      });
      // Check for errors based on CodigoRespuesta
      // "000" = success, anything else = error
      const isSuccess = data.CodigoRespuesta === '000';
      if (!isSuccess) {
        const errorMsg = getErrorMessage(data, response);
        throw new Error(errorMsg);
      }
      // Additional fallback checks for other error formats
      if (!response.ok || data.error || data.status === 'error' || data.success === false) {
        const errorMsg = getErrorMessage(data, response);
        throw new Error(errorMsg);
      }
      // Show success message
      setShowSuccess(true);
      // Reset form
      setFormData({
        firstName: '',
        lastName: '',
        documentNumber: '',
        nationality: 'Ecuador',
        country: 'Ecuador',
        email: '',
        phoneCode: '+593',
        phoneNumber: '',
        instagram: '',
        tiktok: '',
        acceptTerms: false,
        isAdult: false
      });
      setDocumentType('cedula');
    } catch (error) {
      console.error('Error al registrar:', error);
      const message = error instanceof Error ? error.message : 'Hubo un error al procesar tu registro. Por favor intenta nuevamente.';
      setErrorMessage(message);
      setShowError(true);
      // Auto hide error after 8 seconds
      setTimeout(() => {
        setShowError(false);
      }, 8000);
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleChange = (field: string, value: any) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    // Clear document error when user types
    if (field === 'documentNumber') {
      setDocumentError('');
    }
  };
  const isFormValid = formData.acceptTerms && formData.isAdult && (formData.instagram.trim() !== '' || formData.tiktok.trim() !== '');
  return <AnimatePresence data-id="element-8">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 pointer-events-none" data-id="element-9" />
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-10">
            <div className="absolute inset-0" onClick={onClose} data-id="element-11" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="bg-[#0a0a0a] border border-white/10 rounded-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden shadow-2xl relative z-10" data-id="element-12">
              {/* Error Message */}
              {showError && <motion.div initial={{
            opacity: 0,
            y: -20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} className="absolute top-0 left-0 right-0 z-40 p-4 bg-red-500/90 backdrop-blur-sm" data-id="element-13">
                  <div className="flex items-start gap-3" data-id="element-14">
                    <AlertCircleIcon className="w-5 h-5 text-white flex-shrink-0 mt-0.5" data-id="element-15" />
                    <div className="flex-1" data-id="element-16">
                      <h4 className="font-semibold text-white mb-1" data-id="element-17">
                        Error en el registro
                      </h4>
                      <p className="text-sm text-white/90" data-id="element-18">{errorMessage}</p>
                    </div>
                    <button onClick={() => setShowError(false)} className="text-white/80 hover:text-white transition-colors" data-id="element-19">
                      <XIcon className="w-5 h-5" data-id="element-20" />
                    </button>
                  </div>
                </motion.div>}

              {/* Success Message */}
              {showSuccess && <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} className="absolute inset-0 bg-[#0a0a0a]/95 backdrop-blur-lg z-50 flex flex-col items-center justify-center p-8 overflow-y-auto" data-id="element-21">
                  <motion.div initial={{
              scale: 0
            }} animate={{
              scale: 1
            }} transition={{
              delay: 0.2,
              type: 'spring',
              stiffness: 200
            }} data-id="element-22">
                    <CheckCircle2Icon className="w-24 h-24 text-[#d4af37] mb-6" data-id="element-23" />
                  </motion.div>

                  <motion.h3 initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.3
            }} className="text-3xl md:text-4xl font-bold text-white mb-6 text-center" data-id="element-24">
                    ¡BIENVENIDO A ELITE CREATOR PASS!
                  </motion.h3>

                  <motion.p initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.4
            }} className="text-base md:text-lg text-gray-300 text-center max-w-2xl leading-relaxed mb-8" data-id="element-25">
                    Para habilitar tu usuario tenemos que realizar diferentes
                    validaciones, ya que debemos garantizar tu identidad ante
                    todos los comercios, organizaciones e instituciones que te
                    darán los beneficios. Por favor, acepta los requerimientos
                    de validación que te enviaremos al correo, teléfono y redes
                    sociales, ya que son indispensables para la activación. El
                    proceso es automático, por lo que si respondes rápido
                    quedarás prontamente habilitado. ¡Estamos ansiosos y
                    emocionados en tenerte como parte de nuestra comunidad!
                  </motion.p>

                  <motion.button initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.5
            }} onClick={() => {
              setShowSuccess(false);
              onClose();
            }} className="px-10 py-4 bg-gradient-to-r from-[#d4af37] to-[#f4d03f] text-black font-bold rounded-full text-lg hover:shadow-2xl hover:shadow-[#d4af37]/50 transition-all duration-300 hover:scale-105" data-id="element-26">
                    Aceptar
                  </motion.button>
                </motion.div>}

              <div className="sticky top-0 bg-[#0a0a0a]/95 backdrop-blur-md border-b border-white/10 px-6 py-4 flex items-center justify-between" data-id="element-27">
                <h2 className="text-2xl font-bold bg-gradient-to-r from-[#d4af37] to-[#f4d03f] bg-clip-text text-transparent" data-id="element-28">
                  Solicitar Elite Creator Pass
                </h2>
                <button onClick={onClose} className="w-10 h-10 flex items-center justify-center rounded-full bg-white/5 hover:bg-white/10 transition-colors" data-id="element-29">
                  <XIcon className="w-5 h-5 text-gray-400" data-id="element-30" />
                </button>
              </div>

              <form onSubmit={handleSubmit} className="px-6 py-8 overflow-y-auto max-h-[calc(85vh-80px)]" data-id="element-31">
                <p className="text-gray-400 mb-6 text-center" data-id="element-32">
                  Completa el formulario para solicitar tu tarjeta de beneficios
                  gratuita
                </p>

                {/* Personal Information */}
                <div className="space-y-4 mb-6" data-id="element-33">
                  <h3 className="text-lg font-semibold text-white mb-3" data-id="element-34">
                    Información Personal
                  </h3>

                  <div className="grid md:grid-cols-2 gap-4" data-id="element-35">
                    <div data-id="element-36">
                      <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-37">
                        Nombre/s *
                      </label>
                      <input type="text" required value={formData.firstName} onChange={e => handleChange('firstName', e.target.value)} className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-[#d4af37] transition-colors" placeholder="Tu nombre" data-id="element-38" />
                    </div>

                    <div data-id="element-39">
                      <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-40">
                        Apellido/s *
                      </label>
                      <input type="text" required value={formData.lastName} onChange={e => handleChange('lastName', e.target.value)} className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-[#d4af37] transition-colors" placeholder="Tu apellido" data-id="element-41" />
                    </div>
                  </div>

                  <div data-id="element-42">
                    <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-43">
                      Tipo de Documento *
                    </label>
                    <div className="flex gap-6" data-id="element-44">
                      <label className="flex items-center cursor-pointer" data-id="element-45">
                        <input type="radio" name="documentType" value="cedula" checked={documentType === 'cedula'} onChange={() => setDocumentType('cedula')} className="w-4 h-4 text-[#d4af37] bg-white/5 border-white/10 focus:ring-[#d4af37] focus:ring-2" data-id="element-46" />
                        <span className="ml-2 text-gray-300" data-id="element-47">Cédula</span>
                      </label>
                      <label className="flex items-center cursor-pointer" data-id="element-48">
                        <input type="radio" name="documentType" value="pasaporte" checked={documentType === 'pasaporte'} onChange={() => setDocumentType('pasaporte')} className="w-4 h-4 text-[#d4af37] bg-white/5 border-white/10 focus:ring-[#d4af37] focus:ring-2" data-id="element-49" />
                        <span className="ml-2 text-gray-300" data-id="element-50">Pasaporte</span>
                      </label>
                    </div>
                  </div>

                  <div data-id="element-51">
                    <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-52">
                      Número de{' '}
                      {documentType === 'cedula' ? 'Cédula' : 'Pasaporte'} *
                    </label>
                    <input type="text" required value={formData.documentNumber} onChange={e => {
                  const value = e.target.value;
                  // For cédula, only allow numbers
                  if (documentType === 'cedula') {
                    if (/^\d*$/.test(value) && value.length <= 10) {
                      handleChange('documentNumber', value);
                    }
                  } else {
                    // For pasaporte, allow alphanumeric and limit to 13
                    if (/^[A-Za-z0-9]*$/.test(value) && value.length <= 13) {
                      handleChange('documentNumber', value);
                    }
                  }
                }} className={`w-full px-4 py-3 bg-white/5 border rounded-lg text-white placeholder-gray-500 focus:outline-none transition-colors ${documentError ? 'border-red-500 focus:border-red-500' : 'border-white/10 focus:border-[#d4af37]'}`} placeholder={documentType === 'cedula' ? 'Ingresa 10 dígitos numéricos' : 'Ingresa entre 3 y 13 caracteres alfanuméricos'} data-id="element-53" />
                    {documentError && <p className="mt-2 text-sm text-red-400" data-id="element-54">
                        {documentError}
                      </p>}
                    <p className="mt-1 text-xs text-gray-500" data-id="element-55">
                      {documentType === 'cedula' ? 'La cédula debe tener exactamente 10 dígitos numéricos' : 'El pasaporte debe tener entre 3 y 13 caracteres alfanuméricos'}
                    </p>
                  </div>

                  <div className="grid md:grid-cols-2 gap-4" data-id="element-56">
                    <div data-id="element-57">
                      <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-58">
                        Nacionalidad *
                      </label>
                      <select required value={formData.nationality} onChange={e => handleChange('nationality', e.target.value)} className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-lg text-white focus:outline-none focus:border-[#d4af37] transition-colors" data-id="element-59">
                        {countries.map(country => <option key={country} value={country} data-id="element-60">
                            {country}
                          </option>)}
                      </select>
                    </div>

                    <div data-id="element-61">
                      <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-62">
                        País de Residencia *
                      </label>
                      <select required value={formData.country} onChange={e => handleChange('country', e.target.value)} className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-lg text-white focus:outline-none focus:border-[#d4af37] transition-colors" data-id="element-63">
                        {countries.map(country => <option key={country} value={country} data-id="element-64">
                            {country}
                          </option>)}
                      </select>
                    </div>
                  </div>
                </div>

                {/* Contact Information */}
                <div className="space-y-4 mb-6" data-id="element-65">
                  <h3 className="text-lg font-semibold text-white mb-3" data-id="element-66">
                    Información de Contacto
                  </h3>

                  <div data-id="element-67">
                    <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-68">
                      E-mail *
                    </label>
                    <input type="email" required value={formData.email} onChange={e => handleChange('email', e.target.value)} className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-[#d4af37] transition-colors" placeholder="tu@email.com" data-id="element-69" />
                  </div>

                  <div data-id="element-70">
                    <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-71">
                      Celular *
                    </label>
                    <div className="grid grid-cols-3 gap-3" data-id="element-72">
                      <select required value={formData.phoneCode} onChange={e => handleChange('phoneCode', e.target.value)} className="col-span-1 px-3 py-3 bg-white/5 border border-white/10 rounded-lg text-white focus:outline-none focus:border-[#d4af37] transition-colors text-sm" data-id="element-73">
                        {phoneCodes.map(({
                      code,
                      country
                    }) => <option key={`${code}-${country}`} value={code} data-id="element-74">
                            {code} {country}
                          </option>)}
                      </select>
                      <input type="tel" required value={formData.phoneNumber} onChange={e => handleChange('phoneNumber', e.target.value)} className="col-span-2 px-4 py-3 bg-white/5 border border-white/10 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-[#d4af37] transition-colors" placeholder="999999999" data-id="element-75" />
                    </div>
                  </div>
                </div>

                {/* Social Media */}
                <div className="space-y-4 mb-6" data-id="element-76">
                  <h3 className="text-lg font-semibold text-white mb-3" data-id="element-77">
                    Redes Sociales
                  </h3>
                  <p className="text-sm text-gray-400 mb-4" data-id="element-78">
                    * Al menos una red social es requerida
                  </p>

                  <div data-id="element-79">
                    <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-80">
                      Instagram
                    </label>
                    <div className="relative" data-id="element-81">
                      <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500" data-id="element-82">
                        @
                      </span>
                      <input type="text" value={formData.instagram} onChange={e => handleChange('instagram', e.target.value)} className="w-full pl-8 pr-4 py-3 bg-white/5 border border-white/10 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-[#d4af37] transition-colors" placeholder="tuusuario" data-id="element-83" />
                    </div>
                  </div>

                  <div data-id="element-84">
                    <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-85">
                      TikTok
                    </label>
                    <div className="relative" data-id="element-86">
                      <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500" data-id="element-87">
                        @
                      </span>
                      <input type="text" value={formData.tiktok} onChange={e => handleChange('tiktok', e.target.value)} className="w-full pl-8 pr-4 py-3 bg-white/5 border border-white/10 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-[#d4af37] transition-colors" placeholder="tuusuario" data-id="element-88" />
                    </div>
                  </div>
                </div>

                {/* Agreements */}
                <div className="space-y-3 mb-6 p-4 bg-white/5 border border-white/10 rounded-lg" data-id="element-89">
                  <label className="flex items-start cursor-pointer group" data-id="element-90">
                    <input type="checkbox" checked={formData.acceptTerms} onChange={e => handleChange('acceptTerms', e.target.checked)} className="mt-1 w-4 h-4 text-[#d4af37] bg-white/5 border-white/10 rounded focus:ring-[#d4af37] focus:ring-2" data-id="element-91" />
                    <span className="ml-3 text-sm text-gray-300" data-id="element-92">
                      Acepto los{' '}
                      <button type="button" onClick={e => {
                    e.preventDefault();
                    onOpenTerms();
                  }} className="text-[#d4af37] hover:underline" data-id="element-93">
                        Términos y Condiciones
                      </button>{' '}
                      y las{' '}
                      <button type="button" onClick={e => {
                    e.preventDefault();
                    onOpenPrivacy();
                  }} className="text-[#d4af37] hover:underline" data-id="element-94">
                        Políticas de Privacidad y Protección de Datos
                      </button>
                      {' *'}
                    </span>
                  </label>

                  <label className="flex items-start cursor-pointer group" data-id="element-95">
                    <input type="checkbox" checked={formData.isAdult} onChange={e => handleChange('isAdult', e.target.checked)} className="mt-1 w-4 h-4 text-[#d4af37] bg-white/5 border-white/10 rounded focus:ring-[#d4af37] focus:ring-2" data-id="element-96" />
                    <span className="ml-3 text-sm text-gray-300" data-id="element-97">
                      Soy mayor de 18 años *
                    </span>
                  </label>
                </div>

                {/* Submit Button */}
                <button type="submit" disabled={!isFormValid || isSubmitting} className={`w-full py-4 rounded-xl font-bold text-lg transition-all duration-300 ${isFormValid && !isSubmitting ? 'bg-gradient-to-r from-[#d4af37] to-[#f4d03f] text-black hover:shadow-lg hover:shadow-[#d4af37]/50 hover:scale-[1.02]' : 'bg-white/5 text-gray-500 cursor-not-allowed'}`} data-id="element-98">
                  {isSubmitting ? 'Enviando...' : 'Enviar Solicitud'}
                </button>

                <p className="text-xs text-gray-500 text-center mt-4" data-id="element-99">
                  * Campos obligatorios
                </p>
              </form>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}